<div>
  <h2>{{ 'Saas::Menu:SaasManagement' | abpLocalization }}</h2>
</div>
<br />
<hr />
<ng-container *ngComponentOutlet="abpSaasSettingGroup"></ng-container>
